export default function MySQL_INSERTINTO() {
  return (
    <div>
      <h2>MySQL_INSERTINTO</h2>    </div>
  );
}